import { config as brandConfig } from '@brand';
const DocumentTitleFormatter = title => {
  return `${title} | ${brandConfig.appName} Patient`;
};

export default DocumentTitleFormatter;
